import 'twin.macro';

import imgRedBar from '../../assets/images/red-bar.png';
import imgRedBarMobile from '../../assets/images/red-bar_mobile.png';

const AnyoneCanWinSection = () => {
  return (
    <>
      <div tw="pt-[166.92%] md:pt-[61.11%] relative w-full flex flex-col bg-anyone-mobile md:bg-anyone-desktop bg-no-repeat bg-center bg-cover">
        <div tw="absolute left-0 top-0 w-full h-full">
          <img
            alt="red bar mobile"
            src={imgRedBarMobile}
            tw="block md:hidden w-full translate-y-[-35%]"
          />
          <img
            alt="red bar"
            src={imgRedBar}
            tw="hidden md:block w-full translate-y-[-35%]"
          />
          <div tw="w-full h-[12vw] md:h-[4vw]" />
          <div
            css={{
              backgroundImage:
                'linear-gradient(180deg, #FFFFFF 32.41%, #A98FBC 100%)',
            }}
            tw="pb-[0.5vw] font-lumadFree text-[4.2vw] md:text-[2vw] text-center leading-[140%] tracking-normal bg-clip-text text-transparent"
          >
            WIN
          </div>
          <div
            css={{
              backgroundImage:
                'linear-gradient(87.69deg, #E13656 22.15%, #A237F5 96.49%)',
            }}
            tw="mx-auto mt-[-4vw] md:mt-[-2.5vw] pb-[3vw] w-[fit-content] font-lumadFree text-[10.2vw] md:text-[6vw] text-center leading-[140%] tracking-normal bg-clip-text text-transparent"
          >
            15,000
          </div>
          <div tw="mt-[-1vw] md:mt-[-1.5vw] pb-[3vw] font-normal font-lumadFree text-[3.8vw] md:text-[1.7vw] text-center leading-[140%] tracking-normal">
            + HUGE Jackpot
            <br />
            Bonuses!
          </div>
          <div tw="w-full h-[28vw] md:h-[8vw]" />
          <div
            css={{
              backgroundImage:
                'linear-gradient(180deg, #FFFFFF 32.41%, #A98FBC 100%)',
            }}
            tw="mx-auto pb-[0.5vw] max-w-[72.82%] md:max-w-none font-lumadFree text-[3.6vw] md:text-[1.3vw] text-center leading-[140%] tracking-normal bg-clip-text text-transparent"
          >
            Everyone gets an early access pass
          </div>
          <div
            css={{
              backgroundImage:
                'linear-gradient(87.69deg, #E13656 22.15%, #A237F5 96.49%)',
            }}
            tw="mx-auto mt-[-0.4vw] md:mt-[-1.5vw] pb-[3vw] w-[fit-content] max-w-[74.82%] md:max-w-none font-lumadFree text-[6.2vw] md:text-[3.6vw] text-center leading-[120%] md:leading-[140%] tracking-normal bg-clip-text text-transparent"
          >
            ANYONE CAN WIN
          </div>
        </div>
      </div>
      <div tw="mx-auto max-w-[76vw] md:max-w-[54vw] pt-[16vw] md:pt-[6vw] pb-[20vw] md:pb-[10vw] font-normal font-lumadFree text-[3.6vw] md:text-[1.7vw] text-center leading-[140%] tracking-normal">
        Be a part of the biggest event in Big Time history…
      </div>
    </>
  );
};

export default AnyoneCanWinSection;
